<template>
  <CCard>
    <CCardHeader class="p-2 font-weight-bold" style="line-height: 2">
      실시간 VPD/HD 분석
    </CCardHeader>
    <CCardBody class="p-2" v-if="emptyFlag"> 데이터 없음</CCardBody>
    <CCardBody class="p-2" :class="emptyFlag ? 'd-none' : ''">
      <div>
        <h6 class="text-center">
          VPD
          <div
            class="btn btn-sm text-white"
            :class="vpd.color"
            style="padding-top: 2px; padding-bottom: 2px"
          >
            {{ vpd.label }}
          </div>
          {{ vpd.value }} (권장 0.5~1.2kPa)
        </h6>
        <div ref="vpdChart" style="width: 100%; height: 250px">chart</div>
      </div>
      <div>
        <h6 class="text-center">
          HD
          <div
            class="btn btn-sm text-white"
            :class="hd.color"
            style="padding-top: 2px; padding-bottom: 2px"
          >
            {{ hd.label }}
          </div>
          {{ hd.value }}
          (권장 3~8 g/m³)
        </h6>
        <div ref="hdChart" style="width: 100%; height: 250px">chart</div>
      </div>

      <div class="row-sensor mt-3">
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 80px">온도</div>
          <div class="sensor-val" style="min-width: 50px">{{ temp }} ℃</div>
        </div>
        <div class="col-sensor">
          <div class="sensor-label" style="min-width: 80px">상대습도</div>
          <div class="sensor-val" style="min-width: 50px">{{ humidity }} %</div>
        </div>
      </div>
      <CCard class="p-0 mt-3">
        <CCardHeader>온실 환경 제어 추천</CCardHeader>
        <CCardBody class="p-2 m-0" v-html="recommendHtml"></CCardBody>
      </CCard>
      <CCard class="p-0 mt-3">
        <CCardHeader>온실 환경 개별 제어</CCardHeader>
        <CCardBody class="p-2 m-0 scc-sort-wrap">
          <CButton
            v-for="(item, key) in control.op"
            :key="key"
            color="light"
            size="sm"
            class="scc-sort-item"
            :disabled="item.disabled"
            @click="onControl(key, item)"
          >
            <i class="fa fa-cog" aria-hidden="true"></i> {{ item.description }}
          </CButton>
        </CCardBody>
      </CCard>

      <CCard class="p-0 mt-3">
        <CCardHeader>온실 환경 기타 제어</CCardHeader>
        <CCardBody class="p-2 m-0 scc-sort-wrap">
          <CButton
            v-for="(item, key) in control.dev"
            :key="key"
            color="light"
            size="sm"
            class="scc-sort-item"
            :disabled="item.disabled"
            @click="onControl(key, item)"
          >
            <i class="fa fa-cog" aria-hidden="true"></i> {{ item.description }}
          </CButton>
        </CCardBody>
      </CCard>
    </CCardBody>
  </CCard>
</template>

<script>
import store from "@/store";
import core from "@/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import MixinsInEnvSensor from "@/mixins/in-env-sensor";

export default {
  name: "RealTimeVpdHdComponent",
  components: {},
  mixins: [MixinsInEnvSensor()],
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          initFlag: false,
          inEnvList: [],
        };
      },
    },
  },
  data() {
    return {
      app: store.state.app,
      emptyFlag: true,
      vpd: {
        label: "",
        color: "",
        value: "",
        chart: null,
      },
      hd: {
        label: "",
        color: "",
        value: "",
        chart: null,
      },
      temp: "",
      humidity: "",
      recommendHtml: "",
      control: {
        op: {
          1: {
            disabled: false,
            description: "1중 천창(좌)",
          },
          3: {
            disabled: false,
            description: "1중 천창(우)",
          },
          5: {
            disabled: false,
            description: "1중 측창(좌)",
          },
          7: {
            disabled: false,
            description: "1중 측창(우)",
          },
          13: {
            disabled: false,
            description: "2중 천창",
          },
          15: {
            disabled: false,
            description: "2중 측창",
          },
          17: {
            disabled: false,
            description: "차광막",
          },
          18: {
            disabled: false,
            description: "보온커튼(상)",
          },
          19: {
            disabled: false,
            description: "보온커튼(전후)",
          },
        },
        dev: {
          1: {
            disabled: false,
            description: "유동팬",
          },
          2: {
            disabled: false,
            description: "배기팬",
          },
          3: {
            disabled: false,
            description: "난방기",
          },
          4: {
            disabled: false,
            description: "포그기",
          },
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    "properties.initFlag"(val) {
      this.properties.initFlag = false;
      if (val) {
        this.init();
      }
    },
    "properties.inEnvList"() {
      this.redraw();
    },
    "slider.value"(val) {
      if (val != null) {
        this.redraw();
      }
    },
  },
  methods: {
    onControl(key, item) {
      console.log(`onControl ${key}, `, item);
    },
    toggleControlButton(enableItemList) {
      const control = this.control;
      for (let key in control.op) {
        const item = control.op[key];
        item.disabled = true;
      }
      for (let key in control.dev) {
        const item = control.dev[key];
        item.disabled = true;
      }
      enableItemList.forEach((item) => {
        item.disabled = false;
      });
    },
    init() {
      if (this.vpd.chart == null) {
        this.createVpdChart();
      }
      if (this.hd.chart == null) {
        this.createHdChart();
      }
      this.vpd.chart.data = [];
      this.hd.chart.data = [];
    },
    redraw() {
      const list = this.properties.inEnvList;

      let lastDate = core.date.instance();
      const dataList = this.getFilterDataList(list, lastDate);
      const avgList = this.getAvgDataList(dataList);
      if (dataList.length > 0) {
        this.emptyFlag = false;

        const sensor = dataList[dataList.length - 1];
        const transpiration = sensor.transpiration;
        //console.log(transpiration);
        this.vpd.label = transpiration.vpdLabel;
        this.vpd.color = transpiration.vpdColor;
        this.vpd.value = sensor.vpd;
        this.hd.label = transpiration.hdLabel;
        this.hd.color = transpiration.hdColor;
        this.hd.value = sensor.hd;

        this.temp = sensor.temp.toFixed(2);
        this.humidity = sensor.humidity.toFixed(2);

        let recommendTemp = transpiration.recommend.temp;
        let recommendHumidity = transpiration.recommend.humidity;

        const hd = this.hd.value;
        if (hd < 3) {
          this.recommendHtml = `온실 내 습도가 <span class="label bg-color-red">과다</span>하니
            온도를 ${recommendTemp}도 까지 올리거나 습도를 ${recommendHumidity}%까지 낮추기위해 아래와 같은 온실제어를 추천드립니다.
             `;
          const control = this.control;
          const enableItemList = [
            control.op[1],
            control.op[3],
            control.op[5],
            control.op[7],
            control.op[13],
            control.op[15],
            control.op[17],
          ];
          this.toggleControlButton(enableItemList);
        } else if (hd > 8) {
          this.recommendHtml = `온실 내 습도가 <span class="label bg-color-orange">부족</span>하니
            온도를 ${recommendTemp}도 까지 낮추거나 습도를 ${recommendHumidity}%까지 올리기위해 아래와 같은 온실제어를 추천드립니다.
             `;

          const control = this.control;
          const enableItemList = [control.dev[4]];
          this.toggleControlButton(enableItemList);
        } else {
          this.recommendHtml = `온실 내 습도가 <span class="label bg-color-green-dark">적절</span>하여 <strong>현재 온실제어</strong> 상황을 유지합니다.`;
          this.toggleControlButton([]);
        }
      } else {
        this.emptyFlag = true;
        this.vpd.label = "";
        this.vpd.color = "";
        this.vpd.value = "";
        this.hd.label = "";
        this.hd.class = "";
        this.hd.value = "";
        this.recommendHtml = "추천할 데이터가 없습니다.";
      }
      if (this.vpd.chart != null) {
        this.vpd.chart.data = dataList;
      } else {
        console.log("is not ready vpd chart");
      }
      if (this.hd.chart != null) {
        this.hd.chart.data = dataList;
      } else {
        console.log("is not ready hd chart");
      }
    },
    createVpdChart() {
      const $el = this.$refs.vpdChart;
      const chart = core.amchart.createXYDateChart($el);
      const dateFieldName = "date";
      let series = core.amchart.createLineSeries(
        chart,
        "vpd",
        dateFieldName,
        "실시간",
        null,
        "kPa",
      );

      const valueAxis = chart.customItem.valueAxis;

      // 범위 오류
      core.amchart.addLineChartRange(valueAxis, series, -9999, 0, "#000");
      // 부족
      core.amchart.addLineChartRange(valueAxis, series, 0, 0.5, "#d7810a");
      // 적합
      core.amchart.addLineChartRange(valueAxis, series, 0.5, 1.2, "#517951");
      // 과다
      core.amchart.addLineChartRange(valueAxis, series, 1.2, 9999, "#cd153f");

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      series = core.amchart.createColumnSeries(
        chart,
        "avgVpd",
        dateFieldName,
        "누적",
        null,
        "kPa",
      );

      core.amchart.addColumnChartAdapter(series, (value) => {
        if (0 <= value && value < 0.5) {
          return am4core.color("#d7810a");
        } else if (0.5 <= value && value < 1.2) {
          return am4core.color("#517951");
        } else if (1.2 <= value) {
          return am4core.color("#cd153f");
        } else {
          return am4core.color("#000");
        }
      });

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      const scrollbarX = new am4core.Scrollbar();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;
      this.vpd.chart = chart;
    },
    createHdChart() {
      const $el = this.$refs.hdChart;
      const chart = core.amchart.createXYDateChart($el);

      const dateFieldName = "date";
      let series = core.amchart.createLineSeries(
        chart,
        "hd",
        dateFieldName,
        "실시간",
        null,
        "kPa",
      );

      const valueAxis = chart.customItem.valueAxis;

      // 범위 오류
      core.amchart.addLineChartRange(valueAxis, series, -9999, 0, "#000");
      // 부족
      core.amchart.addLineChartRange(valueAxis, series, 0, 3, "#d7810a");
      // 적합
      core.amchart.addLineChartRange(valueAxis, series, 3, 8, "#517951");
      // 과다
      core.amchart.addLineChartRange(valueAxis, series, 8, 9999, "#cd153f");

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      series = core.amchart.createColumnSeries(
        chart,
        "avgHd",
        dateFieldName,
        "누적",
        null,
        "kPa",
      );

      core.amchart.addColumnChartAdapter(series, (value) => {
        if (0 <= value && value < 3) {
          return am4core.color("#d7810a");
        } else if (3 <= value && value < 8) {
          return am4core.color("#517951");
        } else if (8 <= value) {
          return am4core.color("#cd153f");
        } else {
          return am4core.color("#000");
        }
      });

      series.tooltip.pointerOrientation = "vertical";
      series.tooltip.background.cornerRadius = 10;
      series.tooltip.background.fillOpacity = 1;
      series.tooltip.label.padding(5, 10, 5, 10);
      series.tooltip.label.fill = am4core.color("#000");
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#fff");
      series = null;

      const scrollbarX = new am4core.Scrollbar();
      chart.cursor = new am4charts.XYCursor();
      chart.scrollbarX = scrollbarX;

      chart.data = null;
      this.hd.chart = chart;
    },
  },
};
</script>
